import Dialog from "components/ui/Dialog/Dialog";
import { useDialog } from "context/DialogContext";
import Button from "components/ui/Button/Button";
import Trans from "features/translation/components/Trans";

const GroupDelete = () => {
  const { hideDialog } = useDialog();

  return (
    <Dialog title={ `Groep verwijderen` }>
      <div className={ "dialog__row" }>
        <Trans
          text={ `Het is niet mogelijk een groep te verwijderen omdat er mogelijk nog actieve leden in de groep zijn.` }
          variables={ { '@email': 'helpdesk@anbo.nl' } }
        />
      </div>
      <div className={ "dialog__row" }>
        <strong>
        <Trans
          text={ "U kunt de groep aan een ander lid overdragen of laten verwijderen door een e-mail te sturen naar @email, vermeld daarbij uw naam en de naam van deze groep." }
          variables={ { '@email': 'helpdesk@anbo.nl' } }
        />
        </strong>
      </div>
      <div className="dialog__buttons dialog__buttons--end">
        <Button variant={ `secondary` } onClick={ hideDialog }>Sluiten</Button>
      </div>
    </Dialog>
  )
}

export default GroupDelete;
